import { Breakpoints, css, styled, ThemeDefinition } from '@vw-marketing/us-components';

import { VWTheme } from '../../../shared/typings/vw-theme';

export const NavigationContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }: { theme: VWTheme }) => theme.size.static450};
  justify-content: space-between;
  max-width: ${({ theme }: { theme: VWTheme }) => theme.size.grid020};
  opacity: 1;
  width: 100%;

  button p {
    width: 100%;
  }

  button span {
    font-size: 16px;
  }

  @media (max-width: ${Breakpoints.b1280}px) {
    min-height: 400px;
    height: 80vh;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    gap: 40px;
    max-width: ${({ theme }: { theme: VWTheme }) => theme.size.grid005};

    button span {
      font-size: 20px;
    }
  }
`;

export const NavigationContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  width: 100%;
`;

export const NavigationItems = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static150};
      justify-content: start;
      padding-top: ${theme.size.static250};
      
      @media (min-width: ${Breakpoints.b560}px) {
        padding-top: ${theme.size.static350};
      }
        
      @media (min-width: ${Breakpoints.b1280}px) {
        padding-top: ${theme.size.static300};
        padding-bottom: ${theme.size.static300};
      }
	  `;
  }}
`;

export const StyledDealerContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static250};
      width: 100%;
      font-weight: 400;
      
      p:first-child {
        font-weight: 400 !important;
      }
      
      @media (min-width: ${Breakpoints.b560}px) {
        gap: ${theme.size.static350};
      }
        
      @media (min-width: ${Breakpoints.b1280}px) {
        gap: ${theme.size.static300};
      }
    `;
  }}
`;

export const NavigationDivider = styled.div<{ hideOnMobile?: boolean }>`
  @media (max-width: ${Breakpoints.b1280}px) {
    ${(props) => props.hideOnMobile && 'display: none'};
  }

  border-bottom: ${({ theme }) => theme.colors.border.divider} 1px solid;
  height: 2px;
  width: 100%;
`;

interface NavigationItemContainerProps {
  isSelected: boolean;
  hasTitle: boolean;
  disabled?: boolean;
  theme: ThemeDefinition;
  flag: boolean;
}

export const NavigationItemContainer = styled.div`
  ${({ isSelected, hasTitle, disabled, theme, flag }: NavigationItemContainerProps) => {
    return css`
      align-items: center;
      background-color: ${isSelected
        ? (flag ? theme.colors.background.highlight : theme.colors.filter.off.disabled)
        : theme.colors.background.primary
      };
      border-radius: 5px;
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
      display: flex;
      gap: 20px;
      height: ${hasTitle ? '100%' : '48px'};
      justify-content: center;
      min-width: 236px;
      opacity: ${disabled ? 0.5 : 1};
      padding: ${theme.size.static200} ${theme.size.static150};
      pointer-events: ${disabled ? 'none' : 'auto'};
      transition: background-color 200ms linear;
      width: 100%;

      > svg {
        flex-shrink: 0;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        ${!disabled && !isSelected && css`
            :hover {
              background-color: ${flag ? theme.colors.background.highlight : theme.colors.background.tertiary};
            }
          `
        }
      }

      @media (max-width: ${Breakpoints.b1280}px) {
        ${!disabled && css`
          :active {
            background-color: ${flag ? theme.colors.button.primary.active : theme.colors.background.tertiary};
            transition: background-color 400ms linear;
          }
        `}
      }

      p {
        color: ${isSelected ? theme.colors.content.active : theme.colors.content.primary};
      }
    `;
  }
  }`;

interface StyledTitleContainerProps {
  hasTitle: boolean;
  isSelected: boolean;
  theme: VWTheme;
}

export const StyledTitleContainer: any = styled.div`
  ${({ hasTitle, isSelected, theme }: StyledTitleContainerProps) => {
    return `
      display: flex;
      flex-direction: ${hasTitle ? 'column' : 'row'};
      gap: ${hasTitle ? theme.size.static100 : 0};
      width: 100%;

      ${hasTitle &&
      `
        p:first-child {
          color: ${isSelected ? theme.colors.content.active : theme.colors.content.secondary};
        }
      `
      }
    `;
  }}
`;
